import eventService from '@/services/event.service'

import { createGenericStore } from './generic.store'

export const useEventStore = createGenericStore<TEvent>(
  'events',
  eventService,
  1000,
)
